// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2MLbj","label":"Radio_label__3Yeqs","checkMark":"Radio_checkMark__338Vs","disabled":"Radio_disabled__3gUZj"};